import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter as Router } from 'react-router-dom'
import App from './App'
import '@fontsource-variable/geist'
import '@fontsource-variable/geist-mono'
import './index.css'
import { PlaceNamesProvider } from './contexts/PlaceNamesContext'

// Create router options with future flags
const routerOptions = {
  future: {
    v7_startTransition: true,
    v7_relativeSplatPath: true
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Router {...routerOptions}>
      <PlaceNamesProvider>
        <App />
      </PlaceNamesProvider>
    </Router>
  </React.StrictMode>,
)